import { t } from "@/i18n-js/instance";
import type { Paywall } from "@/react/types/Paywall";
import type { PaywallPrice } from "@/react/types/PaywallPrice";

export const displayName = (paywall: Paywall): string =>
  paywall.name || paywall.display_name;

const preferredPrice = (paywall: Paywall): PaywallPrice | undefined =>
  paywall.stripe_prices_attributes.find(
    (price_attribute: PaywallPrice) => price_attribute.preferred,
  ) ?? paywall.stripe_prices_attributes[0];

export const displayPreferredPrice = (paywall: Paywall): string => {
  const priceToDisplay = preferredPrice(paywall);

  return (
    priceToDisplay?.short_description ||
    t("settings.paywalls.list.form.no_preferred_price_selected")
  );
};
